import { consulta, generarFiltros } from '../../../../global/js/funciones';


/** Linea de estados de una solicitud de bienestar. */
export const fetchLineaBienestar = (bienestarId = 0) => new Promise((resolve) => {
	consulta(`api/v1.0/bienestar/linea/${bienestarId}`, null, null, (error, estado, resp) => {
		resolve(estado === 200 && !error ? resp : null);
	});
});


/** Historial de estados de una solicitud de bienestar. */
export const fetchEstadosHistoriaBienestar = async (bienestarId = 0) => {
	try {
		const f = await generarFiltros([{ llave: 'bienestar', valor: bienestarId }]);
		return new Promise((resolve) => {
			consulta(`api/v1.0/bienestar/estados?${f}`, null, null, (error, estado, resp) => {
				resolve(!error && estado === 200 && Array.isArray(resp) ? resp : []);
			});
		});
	} catch (err) {
		return [];
	}
};


/** Estados configurados para un tipo de solicitud. */
export const fetchEstadosPorSolicitud = (tipoSolicitud = '', tipoServicio = '', bienestarId = '') => new Promise((resolve) => {
	try {
		const params = [];
		if (tipoServicio) params.push(`servicio=${tipoServicio}`);
		if (bienestarId) params.push(`bienestar=${bienestarId}`);
		const qs = params.length ? `?${params.join('&')}` : '';
		consulta(`api/v1.0/bienestar/linea_estados/${tipoSolicitud}${qs}`, null, null, (error, estado, resp) => {
			if (!error && estado === 200) {
				const estados = Array.isArray(resp?.estados_linea) ? resp.estados_linea : (Array.isArray(resp) ? resp : []);
				resolve(estados);
				return;
			}
			resolve([]);
		});
	} catch (err) {
		resolve([]);
	}
});


/** Solicitudes de bienestar para estudiante. */
export const fetchSolicitudesBienestarEstudiante = async (filtros = []) => {
	const f = await generarFiltros(filtros);
	return new Promise((resolve) => {
		consulta(`api/v1.0/bienestar_estudiantil/listar/0?${f}`, null, null, (error, estado, resp) => {
			if (estado === 200 && !error) {
				if (Array.isArray(resp)) {
					resolve(resp);
				} else if (resp?.general && Array.isArray(resp.general)) {
					resolve(resp.general);
				} else if (resp?.resultados && Array.isArray(resp.resultados)) {
					resolve(resp.resultados);
				} else {
					resolve([]);
				}
			} else {
				resolve([]);
			}
		});
	});
};
